import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=5e2d056c&scoped=true"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=5e2d056c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d056c",
  null
  
)

export default component.exports